import { useMemo } from 'react';
import { BannersDTO } from './types';
import { CreateModal } from './components/modals/CreateModal';
import { EditModal } from './components/modals/EditModal';
import { DeleteModal } from './components/modals/DeleteModal';

export enum MODALS {
  CREATE_BANNER = 'CREATE_BANNER',
  EDIT_BANNER = 'EDIT_BANNER',
  DELETE_BANNER = 'DELETE_BANNER',
}

export type ModalKeys = keyof typeof MODALS;

interface chooseModalProps {
  choosenModal: ModalKeys | null;
  updateBannerAfterDelete: () => void;
  updateBannerAfterCreate: (page: BannersDTO) => void;
  updateBannerAfterEdit: (editedPage: BannersDTO) => void;
  selectedBanner: BannersDTO | null;
  closeModal: () => void;
}

export const ChooseModal = ({
                              selectedBanner,
                              closeModal,
                              choosenModal,
                              updateBannerAfterEdit,
                              updateBannerAfterCreate,
                              updateBannerAfterDelete,
                            }: chooseModalProps) => {
  const modal = useMemo(() => {
    switch (choosenModal) {
      case MODALS.CREATE_BANNER:
        return (
          <CreateModal
            updateBannerAfterCreate={updateBannerAfterCreate}
            open
            onClose={() => closeModal()}
          />
        );
      case MODALS.EDIT_BANNER:
        return (
          selectedBanner ? (
            <EditModal
              updateBannerAfterEdit={updateBannerAfterEdit}
              banner={selectedBanner}
              open
              onClose={() => closeModal()}
            />
          ) : <></>
        );
      case MODALS.DELETE_BANNER:
        return (
          selectedBanner?.id ? (
            <DeleteModal
              open
              onClose={closeModal}
              bannerId={selectedBanner.id}
              updateBannerAfterDelete={updateBannerAfterDelete} />
          ) : <></>
        );
      default:
        return <></>;
    }
  }, [
    choosenModal,
    closeModal,
    selectedBanner,
    updateBannerAfterCreate,
    updateBannerAfterDelete,
    updateBannerAfterEdit,
  ]);

  return modal;
};
